// actions.ts
import { Dispatch } from "redux";
import {
  ChatViewModel,
  ChatDetailsViewModel,
  CreateChatCommand,
  SendChatMessageCommand,
} from "../../configuration/api/apiSchema";
import { api } from "../../configuration/api/apiHelper";

// Get all chats for the current user (frontend filtering if needed)
export const getChats = () => async (dispatch: Dispatch) => {
  dispatch({ type: "GET_CHATS_REQUEST" });
  try {
    const response = await api.chats.chatsList();
    dispatch({ type: "GET_CHATS_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "GET_CHATS_FAILURE", payload: error });
  }
};

// Get details for a specific chat by its ID
export const getChatDetails = (chatId: string) => async (dispatch: Dispatch) => {
  dispatch({ type: "GET_CHAT_DETAILS_REQUEST" });
  try {
    const response = await api.chats.chatsDetail(chatId);
    dispatch({ type: "GET_CHAT_DETAILS_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "GET_CHAT_DETAILS_FAILURE", payload: error });
  }
};

// Create a new chat with a list of participant IDs and an optional title
export const createChat = (data: CreateChatCommand) => async (dispatch: Dispatch) => {
  dispatch({ type: "CREATE_CHAT_REQUEST" });
  try {
    const response = await api.chats.chatsCreate(data);
    dispatch({ type: "CREATE_CHAT_SUCCESS", payload: response.data });
    return response.data; // returns the new chat ID
  } catch (error) {
    dispatch({ type: "CREATE_CHAT_FAILURE", payload: error });
    throw error;
  }
};

// Send a message in a chat (User message or Event message)
export const sendMessage = (chatId: string, data: SendChatMessageCommand) => async (dispatch: Dispatch) => {
  dispatch({ type: "SEND_MESSAGE_REQUEST" });
  try {
    const response = await api.chats.messagesCreate(chatId, data);
    dispatch({ type: "SEND_MESSAGE_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "SEND_MESSAGE_FAILURE", payload: error });
  }
};
